// ** React Imports
import {Fragment, useEffect, useState} from 'react'
// ** Table Data & Columns
import {columns} from './components/data'
import "@styles/react/libs/tables/react-dataTable-component.scss"
// ** Third Party Components
import ReactPaginate from 'react-paginate'
import DataTable from 'react-data-table-component'
import {ChevronDown} from 'react-feather'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

// ** Reactstrap Imports
import {  Card } from 'reactstrap'
import './style.scss'
import {useParams} from "react-router-dom";
import InvoicesFilter from './components/filter'
import { useSelector } from 'react-redux'



const MySwal = withReactContent(Swal)

const Invoices = ({ transactions = [] }) => {
    // ** States
    const { data } = useSelector(state => state.customerMasterLatitude)
    const params = useParams();
    const [currentPage, setCurrentPage] = useState(0)
    const [searchValue, setSearchValue] = useState('')
    const [filteredData, setFilteredData] = useState(data)
    const [totalRecords, setTotalRecords] = useState(data.length || 0);

    useEffect(() => {
        setTotalRecords(data.length)
    }, [data])

    const [modal, setModal] = useState(false);


    const [filterData, setFilterData] =
        useState({pageNumber: 1, pageSize: 25, status: +params.statusDocument});


    const onFilter = (filterProp) => {
        setFilterData({...filterData, ...filterProp});
    }

    const toggleModal = (show, document) => {
        setModal(show);
        if (show && document) {
            getDocumentTracking(document);
        }
    }

    // ** Function to handle Pagination
    const handlePagination = page => {
        setCurrentPage(page.selected);
    }

    // ** Pagination Previous Component
    const Previous = () => {
        return (
            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Anterior</span>
            </Fragment>
        )
    }

    // ** Pagination Next Component
    const Next = () => {
        return (
            <Fragment>
                <span className='align-middle d-none d-md-inline-block'>Siguiente</span>
            </Fragment>
        )
    }

    const CustomPagination = () => (
        <ReactPaginate
            previousLabel={<Previous/>}
            nextLabel={<Next/>}
            forcePage={currentPage}
            onPageChange={page => handlePagination(page)}
            pageCount={Math.ceil(totalRecords / 25)}
            breakLabel={'...'}
            pageRangeDisplayed={2}
            marginPagesDisplayed={2}
            activeClassName={'active'}
            pageClassName={'page-item'}
            nextLinkClassName={'page-link'}
            nextClassName={'page-item next'}
            previousClassName={'page-item prev'}
            previousLinkClassName={'page-link'}
            pageLinkClassName={'page-link'}
            breakClassName='page-item'
            breakLinkClassName='page-link'
            containerClassName={'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'}
        />
    )

    return (
        <Fragment>
            <InvoicesFilter onFilter={onFilter} />
            <Card>
                <div className={`react-dataTable master-view-batch-table`}>
                    {data.length > 0 && (
                    <DataTable
                        noHeader
                        pagination
                        columns={columns(toggleModal)}
                        paginationPerPage={25}
                        className='react-dataTable'
                        responsive={true}
                        sortIcon={<ChevronDown size={10}/>}
                        paginationComponent={CustomPagination}
                        paginationDefaultPage={currentPage + 1}
                        data={searchValue.length ? filteredData : data}
                    />
                    )}
                </div>
            </Card>

        </Fragment>
    )
}

export default Invoices
